"use client";

import { type Container } from "inversify";

import { createContext } from "../common";

const [useContainer, ContainerProvider] = createContext<Container>();

export { ContainerProvider, useContainer };
